export const paginationGetters = (key = 'pagination') => {
  return {
    getPagination: state => state[key],
    hasMorePage: state => state[key].page < state[key].lastPage,
    getTotalPagination: state => state[key].total,
  }
}

export const paginationItemsGetter = (itemGetter) => (state, getters) => {
  const { ids } = getters.getPagination
  const getter = itemGetter(state, getters);

  return ids.map(getter)
}
